import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { GlobalFilterProvider } from "./lib/context/GlobalFilterProvider";
import reportWebVitals from "./reportWebVitals";
import { applyTheme } from "./lib/utils/utility";
import { ThemeProvider } from "@emotion/react";
import { muiTheme } from "./lib/utils/themeProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
let storedTheme;
try {
  storedTheme = localStorage.getItem("theme");
} catch (e) {
  storedTheme = null;
}
const htmlTheme = document.documentElement.getAttribute("data-theme");
const theme = storedTheme || htmlTheme || "light";
applyTheme(theme);

root.render(
  <React.StrictMode>
    <GlobalFilterProvider>
      <ThemeProvider theme={muiTheme}>
        <App />
      </ThemeProvider>
    </GlobalFilterProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
